/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_Btn_SignInputs */

const tr_landing_telegram_mock_btn_sign = /** @type {(inputs: Landing_Telegram_Mock_Btn_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İmzala`)
};

const en_landing_telegram_mock_btn_sign = /** @type {(inputs: Landing_Telegram_Mock_Btn_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign`)
};

const de_landing_telegram_mock_btn_sign = /** @type {(inputs: Landing_Telegram_Mock_Btn_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signieren`)
};

const ru_landing_telegram_mock_btn_sign = /** @type {(inputs: Landing_Telegram_Mock_Btn_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписать`)
};

/**
* | output |
* | --- |
* | "Sign" |
*
* @param {Landing_Telegram_Mock_Btn_SignInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_btn_sign = /** @type {((inputs?: Landing_Telegram_Mock_Btn_SignInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_Btn_SignInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_btn_sign(inputs)
	if (locale === "de") return de_landing_telegram_mock_btn_sign(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_btn_sign(inputs)
	return tr_landing_telegram_mock_btn_sign(inputs)
});